// MAIN PAGE COMPONENT, DISPLAYS HOMEITEM COMPONENTS

import React, { useContext, useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { LanguageContext } from "./../language-context";
import { Link } from "react-router-dom";
import * as variables from "./helper/Variables";
import styled from "styled-components";
import { HomeItem } from "./HomeItem";
import { PopUp } from "./PopUp";
import { pl } from "./../data/pl";
import { CycleItem } from "./CycleItem";

const Paintings = styled.article`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 2rem;
  width: 100vw;
  height: 100vh;
  padding: 2rem 20vw;
  background-color: ${variables.BACKGROUND_GRAY};

  @media (max-width: 1400px) {
    padding: 6rem 5vw 0;
  }

  @media (max-width: 500px) {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 6rem 2rem;
  }
`;

export const Home = () => {
  const usedLanguage = useContext(LanguageContext);
  const { artworks } = pl; //pl because this data is the same no matter the language

  //const cycleList = pl.cycles.cycles;
  const cycleList = usedLanguage.language.cycles.cycles;

  return (
    <>
      <MetaTags>
        <title>Structuralist | Structural Collage | Interior</title>
        <meta
          name="description"
          content="Michał Król to młody artysta - outsider i samouk, który tworzy kolaż strukturalny. Wszystkie dotychczasowe prace dostępne są na niniejszej, oficjalnej stronie."
        />
        <meta
          name="keywords"
          content={`"Structuralist", "Michał Król", "Structural Collage", "Interior"`}
        />
      </MetaTags>
      <PopUp />
      <Paintings>
        {/* eslint-disable-next-line*/}
        {cycleList.map((cycle) => {
          return (
            <Link
              key={cycle}
              to={`/cycles/${cycle}`}
              style={{ textDecoration: "none" }}
            >
              <CycleItem cycleName={cycle} />
            </Link>
          );
        })}
      </Paintings>
    </>
  );
};
